import type { RootState } from '@/store';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { DailyRewardStatusDto, midleNestApi } from '@/store/services/MidleNestApi.service';

export const REWARDS_FEATURE_KEY = 'rewards';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface RewardsState extends Partial<DailyRewardStatusDto> {}

const initialState: RewardsState = {};

const slice = createSlice({
  name: REWARDS_FEATURE_KEY,
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder.addMatcher(
      midleNestApi.endpoints.dailyRewardControllerGetActiveCampaignStatus.matchFulfilled,
      (state, { payload }) => {
        Object.assign(state, payload);
      },
    ),
});

const rewardsActions = slice.actions;
const rewardsReducer = slice.reducer;

const rewardsState = (state: RootState): RewardsState => state[REWARDS_FEATURE_KEY];

const selectRewardClaims = createSelector(rewardsState, (i) => i.claims);
const selectRewardCampaign = createSelector(rewardsState, (i) => i.campaign);
const selectIsClaimAvailable = createSelector(rewardsState, (i) => i.isAvailableToday);
const selectDaysInMonth = createSelector(rewardsState, (i) => i.daysInMonth);
const selectCurrentDay = createSelector(rewardsState, (i) => i.day);

export {
  rewardsActions,
  rewardsReducer,
  selectIsClaimAvailable,
  selectRewardCampaign,
  selectRewardClaims,
  selectDaysInMonth,
  selectCurrentDay,
};
export default slice;
